import React, { useRef } from "react";
import DCard from "../DCard";
import FormikContainer from "../Formik/FormikContainer";
import { ErrorMessage, Form } from "formik";
import FieldContainer from "../Formik/FieldContainer";
import DImage from "../DImage";
import DButton from "../DButton";
import ErrorMsg from "../Formik/Fields/ErrorMsg";
import { Heading, Spinner } from "@chakra-ui/react";
import QuillEditor from "../QuillEditor";
import DSpinner from "../DSpinner";

const PaymentForm = ({
    initialValues,
    validationSchema,
    onSubmit,
    btnText,
    paymentAr,
    setPaymentAr,
    paymentEn,
    setPaymentEn,
    isLoading = false,
}) => {
    const fileRef = useRef();
    const setImageHandler = value => {
        if (value?.type) {
            return URL.createObjectURL(value);
        }
        return value;
    };
    const deleteImageHandler = setFieldValue => {
        fileRef.current.value = "";
        setFieldValue("img", "");
    };
    return (
        <DCard className={isLoading ? "min-h-[400px] relative" : ""}>
            {isLoading ? (
                <DSpinner />
            ) : (
                <FormikContainer
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ values, isSubmitting, setFieldValue }) => (
                        <Form>
                            <div className="md:flex md:flex-col md:items-center">
                                <div className="mb-4 text-center">
                                    <label
                                        className="block mb-2"
                                        htmlFor="productImage"
                                    >
                                        صورة:
                                    </label>
                                    <FieldContainer
                                        fileRef={fileRef}
                                        name="img"
                                        type="file"
                                        accept="image/*"
                                        id="img"
                                        hidden
                                    />
                                    {values.img && (
                                        <>
                                            <div className="mb-4 relative sm:w-[250px] h-[250px] border border-light-color rounded-sm">
                                                <DImage
                                                    className="w-full h-full object-contain"
                                                    src={setImageHandler(
                                                        values.img
                                                    )}
                                                    alt={"img"}
                                                    load={true}
                                                />
                                            </div>
                                            <DButton
                                                onClick={() =>
                                                    deleteImageHandler(
                                                        setFieldValue
                                                    )
                                                }
                                                className="text-white"
                                                bgColor="danger"
                                            >
                                                حذف الصورة
                                            </DButton>
                                        </>
                                    )}
                                    <DButton
                                        bgColor="secondry"
                                        onClick={() => fileRef.current?.click()}
                                    >
                                        تحميل صورة
                                    </DButton>
                                    <div className="blokc">
                                        <ErrorMessage
                                            name="img"
                                            component={ErrorMsg}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="mb-4">
                                <Heading as="h2" size="md" className="mb-4">
                                    معلومات الدفع (بالعربية)
                                </Heading>
                                <QuillEditor
                                    value={paymentAr}
                                    setValue={setPaymentAr}
                                />
                            </div>
                            <div className="mb-4">
                                <Heading as="h2" size="md" className="mb-4">
                                    معلومات الدفع (بالانجليزي)
                                </Heading>
                                <QuillEditor
                                    value={paymentEn}
                                    setValue={setPaymentEn}
                                />
                            </div>
                            <DButton
                                type="submit"
                                disabled={isSubmitting}
                                className={
                                    "flex items-start rounded-lg justify-center min-w-[150px] text-white mx-auto"
                                }
                            >
                                {isSubmitting ? <Spinner /> : btnText}
                            </DButton>
                        </Form>
                    )}
                </FormikContainer>
            )}
        </DCard>
    );
};

export default PaymentForm;
